import type { BillingPreference } from '@chukua/common';

/** Display labels for `BILLING_PREFERENCES` — the table column, the create form and the edit form all read from this one map. */
export const BILLING_PREFERENCE_LABELS: Record<BillingPreference, string> = {
  per_trip: 'Per trip',
  weekly: 'Weekly',
  monthly: 'Monthly',
  per_po: 'Per PO',
  per_vessel: 'Per vessel',
};
